import React from 'react'
import propsTypes from 'prop-types'

import { v4 as uuidv4 } from 'uuid'

type ButtonHTMLType = 'submit' | 'reset' | 'button'

type ButtonProps = {
  onClick: () => void
  id?: string
  label?: string
  type?: ButtonHTMLType
  className?: string
}

const Button: React.FC<ButtonProps> = ({
  id,
  children,
  onClick,
  className = 'btn',
  // size,
  // color,
  // whatever.
  type = 'button',
  label
}) => (
  <button
    id={id || uuidv4()}
    type={type}
    className={className}
    onClick={onClick}
  >
    { children || label }
  </button>
)

Button.propTypes = {
  onClick: propsTypes.func.isRequired,
  label: propsTypes.string,
  type: propsTypes.oneOf<ButtonHTMLType>(['submit', 'reset', 'button']),
  className: propsTypes.string
}

Button.defaultProps = {
  label: '',
  type: 'button',
  className: 'btn'
}

export default Button
